var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgP2PPlatform = function SvgP2PPlatform(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 260 206.781"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#00a867",
    "data-name": "Group 26390"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "013-income"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M129.887 45.106a62.09 62.09 0 1 0 62.09 62.09 62.09 62.09 0 0 0-62.09-62.09m55.88 62.09a55.6 55.6 0 0 1-3.259 18.627h-12.263a9.314 9.314 0 0 1-9.313-9.314v-3.104h-7.761a4.657 4.657 0 1 1 0-9.314h9.313a10.866 10.866 0 0 0 0-21.731h-10.866a9.314 9.314 0 0 1-.046-18.627h13.359a55.77 55.77 0 0 1 20.836 43.463Zm-111.76 0a55.55 55.55 0 0 1 9.45-31.045h30.113a6.237 6.237 0 0 1 6.209 6.09 6.04 6.04 0 0 1-1.774 4.366 6.55 6.55 0 0 1-4.656 1.962h-6.005a15.522 15.522 0 1 0 0 31.045h7.02a9.314 9.314 0 0 1 9.314 9.313v3.105h9.313a6.209 6.209 0 0 1 0 12.417H88.356a55.6 55.6 0 0 1-14.35-37.253Zm55.88 55.88a55.57 55.57 0 0 1-35.044-12.418h38.148a12.418 12.418 0 0 0 0-24.836h-3.415a15.546 15.546 0 0 0-15.212-12.418h-7.01a9.313 9.313 0 1 1 0-18.626h6.007a12.8 12.8 0 0 0 9.075-3.822 12.22 12.22 0 0 0 3.549-8.833 12.48 12.48 0 0 0-12.418-12.182H88.356a55.536 55.536 0 0 1 67.013-12.417h-3.75a15.522 15.522 0 1 0 0 31.045h10.865a4.657 4.657 0 1 1 0 9.313h-9.313a10.866 10.866 0 1 0 0 21.731h1.863a15.546 15.546 0 0 0 15.211 12.418h9.624a55.88 55.88 0 0 1-49.982 31.045Z",
    "data-name": "Path 10229"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.29 63.733a27.94 27.94 0 1 0-27.94-27.94 27.94 27.94 0 0 0 27.94 27.94m0-49.671a21.731 21.731 0 1 1-21.731 21.731 21.73 21.73 0 0 1 21.731-21.731",
    "data-name": "Path 10230"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.484 150.659a27.94 27.94 0 1 0 27.94 27.94 27.94 27.94 0 0 0-27.94-27.94m0 49.671A21.731 21.731 0 1 1 80.215 178.6a21.73 21.73 0 0 1-21.73 21.731Z",
    "data-name": "Path 10231"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.145 112.84q-.184-2.795-.183-5.644v-.36h-6.21v.36q0 3.045.193 6.044Z",
    "data-name": "Path 10232"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.022 19.085a83 83 0 0 0-6.144-1.863l-1.602 5.995a88 88 0 0 1 5.728 1.751Z",
    "data-name": "Path 10233"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m73.603 41.003-4.036-4.726a97 97 0 0 0-4.74 4.328l4.346 4.436a88 88 0 0 1 4.43-4.038",
    "data-name": "Path 10234"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.069 122.804c.36 2.103.795 4.22 1.297 6.291l6.033-1.463a88 88 0 0 1-1.208-5.87Z",
    "data-name": "Path 10235"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m44.3 91.946-6.113-1.093a91 91 0 0 0-.904 6.36l6.173.67c.217-2.006.496-4 .844-5.937",
    "data-name": "Path 10236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m48.187 77.502-5.847-2.13a91 91 0 0 0-1.989 6.106l5.967 1.717a95 95 0 0 1 1.869-5.693",
    "data-name": "Path 10237"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.546 20.27-.09-6.208c-2.13.03-4.29.14-6.41.31l.521 6.21a88 88 0 0 1 5.979-.311",
    "data-name": "Path 10238"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.184 141.804a76 76 0 0 1-2.208-5.566l-5.852 2.086a91 91 0 0 0 2.372 5.974Z",
    "data-name": "Path 10239"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m63.075 51.65-4.768-3.976a93 93 0 0 0-3.94 5.075l5.047 3.632a77 77 0 0 1 3.661-4.731",
    "data-name": "Path 10240"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.785 32.313-3.167-5.342a91 91 0 0 0-5.404 3.454l3.517 5.117a89 89 0 0 1 5.054-3.23",
    "data-name": "Path 10241"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54.517 63.932-5.387-3.105a93 93 0 0 0-3.007 5.676l5.587 2.722a86 86 0 0 1 2.807-5.293",
    "data-name": "Path 10242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.657 21.785-1.155-6.1a92 92 0 0 0-6.265 1.416l1.584 6.004a86 86 0 0 1 5.836-1.32",
    "data-name": "Path 10243"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.453 15.205c-2.121-.337-4.269-.6-6.376-.785l-.541 6.183c1.966.174 3.969.42 5.948.732Z",
    "data-name": "Path 10244"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m99.26 25.84-2.187-5.809a87 87 0 0 0-5.924 2.485l2.595 5.637a85 85 0 0 1 5.517-2.313",
    "data-name": "Path 10245"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.59 72.587a77 77 0 0 1 2.208 5.567l5.853-2.086a90 90 0 0 0-2.373-5.974Z",
    "data-name": "Path 10246"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.705 91.587a96 96 0 0 0-1.297-6.29l-6.033 1.462a88 88 0 0 1 1.208 5.871Z",
    "data-name": "Path 10247"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m131.229 194.12.089 6.21c2.13-.03 4.29-.14 6.41-.31l-.52-6.21a88 88 0 0 1-5.98.31",
    "data-name": "Path 10248"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m205.257 150.46 5.387 3.105a93 93 0 0 0 3.007-5.676l-5.587-2.723a85 85 0 0 1-2.807 5.294",
    "data-name": "Path 10249"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m211.587 136.89 5.833 2.13a90 90 0 0 0 1.99-6.106l-5.967-1.717a87 87 0 0 1-1.856 5.693",
    "data-name": "Path 10250"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m196.698 162.742 4.77 3.976a93 93 0 0 0 3.94-5.075l-5.033-3.632a83 83 0 0 1-3.677 4.73",
    "data-name": "Path 10251"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m215.474 122.445 6.113 1.093a91 91 0 0 0 .904-6.359l-6.173-.67a85 85 0 0 1-.844 5.936",
    "data-name": "Path 10252"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M216.629 101.552q.184 2.795.183 5.644v.36h6.21v-.36q0-3.045-.197-6.044Z",
    "data-name": "Path 10253"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m160.513 188.552 2.173 5.809a87 87 0 0 0 5.924-2.485l-2.595-5.637a81 81 0 0 1-5.502 2.313",
    "data-name": "Path 10254"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m146.117 192.607 1.153 6.1a92 92 0 0 0 6.265-1.416l-1.585-6.004a85 85 0 0 1-5.833 1.32",
    "data-name": "Path 10255"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.321 199.187c2.12.337 4.269.6 6.376.785l.54-6.183a88 88 0 0 1-5.947-.732Z",
    "data-name": "Path 10256"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m173.99 182.079 3.166 5.342a97 97 0 0 0 5.404-3.455l-3.517-5.116a89 89 0 0 1-5.054 3.229",
    "data-name": "Path 10257"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m186.17 173.389 4.038 4.726a97 97 0 0 0 4.74-4.327l-4.346-4.437a88 88 0 0 1-4.431 4.038",
    "data-name": "Path 10258"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.752 195.306a83 83 0 0 0 6.144 1.863l1.602-5.995a88 88 0 0 1-5.729-1.75Z",
    "data-name": "Path 10259"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.055 192.829v-4.959a11.58 11.58 0 0 0-6.247-10.261 8.265 8.265 0 1 0-10.648 0 11.58 11.58 0 0 0-6.246 10.261v4.959a1.65 1.65 0 0 0 1.65 1.653h19.838a1.65 1.65 0 0 0 1.653-1.65Zm-16.53-21.488a4.959 4.959 0 1 1 4.96 4.959 4.965 4.965 0 0 1-4.96-4.959m13.224 19.835H50.22v-3.306a8.265 8.265 0 0 1 16.53 0Z",
    "data-name": "Path 10282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.789 50.023v-4.959a11.58 11.58 0 0 0-6.246-10.26 8.265 8.265 0 1 0-10.649 0 11.58 11.58 0 0 0-6.246 10.26v4.96a1.65 1.65 0 0 0 1.65 1.652h19.838a1.65 1.65 0 0 0 1.653-1.65ZM196.26 28.535a4.959 4.959 0 1 1 4.959 4.959 4.965 4.965 0 0 1-4.959-4.959m13.223 19.835h-16.53v-3.305a8.265 8.265 0 1 1 16.53 0Z",
    "data-name": "Path 10283"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M57.987 0a6.004 6.004 0 1 0 6.003 6.005v-.002A6.003 6.003 0 0 0 57.988 0Zm0 8.669A2.666 2.666 0 1 1 60.65 6v.002a2.667 2.667 0 0 1-2.663 2.666",
    "data-name": "Path 10362"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.65 119.605a10.076 10.076 0 1 0 10.079 10.077v-.002a10.077 10.077 0 0 0-10.078-10.075m0 14.55a4.474 4.474 0 1 1 4.478-4.475 4.474 4.474 0 0 1-4.477 4.475",
    "data-name": "Path 10363"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.131 50.413a6.566 6.566 0 1 0 6.566 6.566v-.002a6.564 6.564 0 0 0-6.564-6.564Zm0 9.48a2.915 2.915 0 1 1 2.918-2.916 2.915 2.915 0 0 1-2.918 2.916",
    "data-name": "Path 10364"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.708 197.78a4.5 4.5 0 1 0 .002 0Zm0 6.497a1.998 1.998 0 1 1 1.997-2v.004a2 2 0 0 1-1.997 1.996Z",
    "data-name": "Path 10365"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.91 193.752a4.081 4.081 0 1 0 .002 0Zm0 5.892a1.815 1.815 0 1 1 .003 0Z",
    "data-name": "Path 10366"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.312 3.26a2.848 2.848 0 1 0 2.848 2.848 2.85 2.85 0 0 0-2.848-2.849m0 4.111a1.264 1.264 0 1 1 1.265-1.263 1.267 1.267 0 0 1-1.265 1.263",
    "data-name": "Path 10367"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M229.667 150.955a2.848 2.848 0 1 0 2.847 2.848 2.85 2.85 0 0 0-2.847-2.849m0 4.111a1.264 1.264 0 1 1 1.265-1.263 1.267 1.267 0 0 1-1.265 1.263",
    "data-name": "Path 10368"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.434 126.958a6.566 6.566 0 1 0 6.566 6.566v-.002a6.564 6.564 0 0 0-6.564-6.564Zm0 9.48a2.915 2.915 0 1 1 2.918-2.916 2.915 2.915 0 0 1-2.918 2.916",
    "data-name": "Path 10300"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.936 74.067a4.081 4.081 0 1 0 .001 0Zm0 5.892a1.815 1.815 0 1 1 .002 0Z",
    "data-name": "Path 10301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.848 90.354a2.848 2.848 0 1 0 2.848 2.849 2.85 2.85 0 0 0-2.848-2.849m0 4.112a1.264 1.264 0 1 1 1.265-1.263 1.267 1.267 0 0 1-1.265 1.263",
    "data-name": "Path 10304"
  }))))));
};
export { SvgP2PPlatform as ReactComponent };
export default __webpack_public_path__ + "5ffe9d3c03a0ee48ac417937e1b52109.svg";